<!--
 * @Author: cp
 * @Date: 2019-08-22 17:17:11
 * @Description: 拣货
 -->
<template>
  <div v-loading="loading">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
      <!-- v-if="pageListData.length > 0" -->

    </el-card>
    <el-card>
      <div style="padding-left:10px">
        打印次数
        <el-select v-model="printNum" width="100%">
          <el-option v-for="(item) in 10" :key="item" :label="item" :value="item" />
        </el-select>
        <el-select v-model="printIndex" width="100%">
          <el-option v-for="(item) in printers" :key="item.index" :label="item.name" :value="item.index" />
        </el-select>
      </div>
    </el-card>
    <PrintOutInfo ref="PrintOutInfo" @printAll='printDelivery(1)' @callback='callback'></PrintOutInfo>
    <el-card>
      <!-- 任务列表 -->
      <el-table ref="table1" class="fa_table" border :data="pageListData" :height="heightStyleObj"
        @selection-change="handleSelectionChange">
        <el-table-column type="expand" width="50px">
          <template slot-scope="props">
            <el-table :show-header="false" class="son_table" :data="props.row.childrens" row-key="id" default-expand-all>
              <el-table-column class-name="cell1" width="50px">
              </el-table-column>
              <el-table-column class-name="cell2" width="55px">
              </el-table-column>
              <el-table-column width="80px"> </el-table-column>
              <el-table-column width="80px"> </el-table-column>
              <el-table-column width="160px"> </el-table-column>
              <el-table-column width="160px"> </el-table-column>
              <el-table-column width="180px"> </el-table-column>
              <el-table-column prop="goodsName" width="100px" />
              <el-table-column prop="specification" width="100px" />
              <el-table-column prop="batchNumber" width="100px" />
              <el-table-column prop="actualOutboundNumber" width="100px" />
              <el-table-column prop="unit" width="100px" />
              <el-table-column width="180px"> </el-table-column>
              <el-table-column width="180px"> </el-table-column>
              <el-table-column width="99px"> </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="55" />
        <el-table-column show-overflow-tooltip prop="soPrintStatus" label="打印状态" width="80px">
          <template slot-scope="scope">
            <dict-tag :options="dictObj.wms_print_status" :value="scope.row.soPrintStatus" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="soPrintNums" label="打印次数" width="80px" />
        <el-table-column show-overflow-tooltip prop="pickingDate" label="打印日期" width="160px">
          <template slot-scope="scope">
            {{ scope.row.pickingDate ? parseTime(scope.row.pickingDate, '{y}-{m}-{d}') : null }}
          </template>
        </el-table-column>
        <el-table-column prop="specifyDeliveryDate" label="发货日期" style="cursor:pointer;" width="160px">
          <template slot-scope="scope">
            <span v-if="scope.row.specifyDeliveryDateInpShow" class="block">
              <el-date-picker v-model="scope.row.specifyDeliveryDate" type="date" :picker-options="pickerOptions"
                style="width: 140px;"></el-date-picker>
              <el-button type="primary"  circle @click="saveSpecifyDeliveryDate(scope.row)">
              </el-button>
            </span>
            <a v-else @click="specifyDeliveryDateClick(scope.row)">
              <span style="font-weight: bold;">
                {{ scope.row.specifyDeliveryDate ? parseTime(scope.row.specifyDeliveryDate, '{y}-{m}-{d}') : null }}
              </span>
            </a>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="bizId" label="单据编号" width="180px" />
        <el-table-column show-overflow-tooltip prop="goodsName" label="产品名称" width="100px" />/
        <el-table-column show-overflow-tooltip prop="specification" label="规格" width="100px" />
        <el-table-column show-overflow-tooltip prop="batchNumber" label="批号" width="100px" />
        <el-table-column show-overflow-tooltip prop="actualTotal" label="数量" width="100px" />
        <el-table-column show-overflow-tooltip prop="unit" label="单位" width="100px" />
        <el-table-column show-overflow-tooltip prop="itemNumber" label="随货物品" width="180px">
          <template slot-scope="scope">
            <span>{{ scope.row.withTheGoodsText }}{{ scope.row.withOtherContent }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="description" label="订单说明" width="180px" />
        <el-table-column show-overflow-tooltip prop="outboundNote" label="备注" width="100px" />
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>

  </div>
</template>

<script>
import { getDict } from '@/api/common'
import { formatDate } from '@/utils/date.js'
import { getSalesOrders, updateOrderGoodsDate } from '@/api/orderManage'
import PrintOutInfo from './components/PrintOutInfoList' // 销售出货单
import { getLodop } from "@/components/print/LodopFuncs";
export default {
  components: {
    PrintOutInfo
  },
  data() {
    return {
      dictObj: {
        wms_print_status: []
      },
      pickerOptions: {
        disabledDate(time) {
          const date = new Date()
          date.setTime(date.getTime() + 3600 * 1000 * 24)
          return (formatDate(time, 'yyyy-MM-dd') !== formatDate(new Date(), 'yyyy-MM-dd') && formatDate(time, 'yyyy-MM-dd') !== formatDate(date, 'yyyy-MM-dd')) || (time.getFullYear() === new Date().getFullYear() && time.getMonth() !== new Date().getMonth())
        }
      },
      printers: [],
      printIndex: 0,
      printNum: 1,
      queryItems: [
        {
          label: '打印状态',
          field: 'soPrintStatus',
          type: 'select',
          options: [{
            dictLabel: '已打印',
            dictValue: "ydy"
          },
          {
            dictLabel: '未打印',
            dictValue: 'wdy'
          }]
        },
        {
          label: '打印次数',
          field: 'soPrintNums',
          type: 'input',
        },
        {
          label: '打印日期',
          field: 'pickingDate',
          type: 'date',
        },
        {
          label: '单据编号',
          field: 'bizId',
          type: 'input',
        },
        {
          label: '备注',
          field: 'outboundNote',
          type: 'input',
        },
      ],
      // 拣货列表数据
      pageListData: [],
      loading: false,
      searchParam: {
        outboundNote: null,
        bizId: null,
        pickingDate: [],
        soPrintNums: null,
        soPrintStatus: 'ydy',
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      multipleSelection: [],
      orderIds: [],
      dialogTableVisible: false,
      heightStyleObj: 0
    }
  },
  mounted() {
    console.log(window.innerHeight - 425 + 'px');
    this.$nextTick(() => {
      this.heightStyleObj = window.innerHeight - 425 + 'px'
    })

    this.getPageListData()
    this.getDicts(['wms_print_status'])
    setTimeout(() => {
      this.getList()
    }, 1000)
  },
  methods: {
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },
    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 修改日期
    saveSpecifyDeliveryDate(data) {
      this.$confirm('确定要修改这个日期吗？', '修改日期', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        updateOrderGoodsDate(data).then(() => {
          data.specifyDeliveryDateInpShow = false
        }).finally(() => {
          this.loading = false
        })
      }).catch(() => {
        this.getPageListData()
      })
    },
    // 获取打印机列表
    getList() {
      const LODOP = getLodop()
      if (!LODOP) return
      // 获取所有打印机
      let printerNum = LODOP.GET_PRINTER_COUNT()
      let printerList = []
      for (let index = 0; index < printerNum; index++) {
        printerList.push({ index, name: LODOP.GET_PRINTER_NAME(index) })
      }
      this.printers = printerList
      // 获取默认打印机
      let printer = localStorage.getItem(`printer:${this.printerType}`)
      if (printer) {
        this.defaultPrinter = parseInt(printer)
      }
    },
    specifyDeliveryDateClick(data) {
      if (data === null || data === '' || data.orderStatus === 'ylj' || data.orderStatus === 'yqs') {
        return
      }
      data.specifyDeliveryDateInpShow = true
    },
    // 获取拣货列表数据
    getPageListData() {
      this.loading = true
      getSalesOrders(this.searchParam)
        .then(res => {
          this.loading = false
          this.pageListData = res.rows
          this.searchParam.total = res.total
        })
    },
    printDelivery() {
      let orderIds = this.multipleSelection.map(item => item.orderId)
      this.$refs.PrintOutInfo.print2(0, orderIds, this.printIndex, this.printNum)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    callback() {
      this.dialogTableVisible = false
      this.getPageListData()
    }

  }
}
</script>
